<template>
  <div class="kpiset-modal">
    <div ref="KPISetDeleteModal" class="modal fade" data-bs-backdrop="static" id="KPISetDeleteModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div v-if="elementType" class="modal-content bg-primary">
           <div class="modal-header">
             <div class="h5 modal-title text-light">{{ $t("views.kpiSet.edit.headingDeleteKPISetMember") }}</div>
             <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
           </div>
           <div class="modal-body bg-light">
             <div class="text-center my-3">
               <p v-if="elementType === 'kpiSet'" class="fw-bold">{{ this.selectedKPISet.name }}</p>
               <p v-if="elementType === 'kpiSet'"> {{ $t("views.kpiSet.edit.confirmDeleteKPISet") }}</p>
               <p v-else> {{ $t("views.kpiSet.edit.confirmDeleteKPISetElement") }}</p>
             </div>
           </div>
           <div class="modal-footer bg-light">
             <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
             <button @click="deleteElement()" type="button" class="btn btn-sm btn-danger" data-bs-dismiss="modal">{{ $t("general.delete") }}</button>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KPISetDeleteModal',
  mounted () {
    const myModalDialog = document.getElementById('KPISetDeleteModal')

    myModalDialog.addEventListener('shown.bs.modal', event => {
      this.KPISetModalElementName = this.$parent.KPISetModalElementName
    })
  },
  data () {
    return {
      KPISetModalElementName: ''
    }
  },
  computed: {
    selectedKPISet () {
      return this.$store.state.selectedKPISet
    },
    selectedElement () {
      return this.$parent.selectedElement
    },
    elementType () {
      return this.$parent.KPISetModalElementType
    },
    elementId () {
      return this.$parent.KPISetModalElementId
    },
    mode () {
      return this.$parent.KPISetModalMode
    }
  },
  methods: {
    async deleteElement () {
      try {
        this.$store.commit('SET_LOADING_STATUS', true)
        if (this.elementType === 'kpiSet' && !this.selectedKPISet.hasNodes) {
          await this.$store.dispatch('deleteKPISet', this.selectedKPISet.id)
        } else {
          await this.$store.dispatch('deleteKPISetElement', { kpiSetId: this.selectedKPISet.id, elementType: ('kpis'), elementId: this.elementId })
        }
      } finally {
        this.$store.commit('SET_LOADING_STATUS', false)
      }
    }
  }
}
</script>
